import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Typography,
} from "@mui/material";
import { useState } from "react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { Autoplay, EffectCoverflow } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "../../src/styles.css";
import { awardWinners } from "../utils/constants";
import VOCModal from "./VOCModal";
import AwardModal from "./AwardModal";
import { AwardWinners } from "../utils/helper";

export default function Awards() {
  const [openAwardsModal, setOpenAwardsModal] = useState(false);
  const [selectedAwardee, setSelectedAwardee] = useState<AwardWinners | null>(
    null
  );

  return (
    <>
      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        }}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        pagination={true}
        modules={[EffectCoverflow, Autoplay]}
        className="mySwiper"
      >
        {awardWinners.map((awardWinner, index) => (
          <SwiperSlide key={awardWinner?.id} style={{ padding: 0 }}>
            <Card
              sx={{ maxWidth: 345 }}
              onClick={() => {
                setSelectedAwardee(awardWinner);
                setOpenAwardsModal(true);
              }}
            >
              <CardHeader
                avatar={<Avatar src="RIVA_new.png" />}
                subheader={awardWinner.heading}
                title={awardWinner.emp_name}
              />
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src={`awards/${awardWinner?.emp_name}.jpg`}
                  style={{ width: "50%", height: "50%" }}
                  alt={awardWinner?.emp_name}
                />
              </div>
              <CardContent>
                <Typography
                  variant="body2"
                  color="text.primary"
                  style={{ textAlign: "center" }}
                >
                  {awardWinner?.department}
                </Typography>
              </CardContent>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
      {openAwardsModal && (
        <AwardModal
          open={openAwardsModal}
          onClosingAwardModal={() => {
            setOpenAwardsModal(false);
          }}
          selectedAwardee={selectedAwardee}
        />
      )}
    </>
  );
}
